define('controllers/modules/conversation/conversation',[
    // libs
    'underscore', 'backbone', 'mustache', 'utils',
    // services
    'services/user',
    // parent
    'src/controller/controller',
    // sub controllers
    'controllers/modules/calendar/calendar',
    // models
    'models/conversation/conversation',
    'collections/conversation/conversations'
], function(
    // Libs
    _, Backbone, Mustache, U,
    // services
    User,
    // parent
    Controller,
    // sub controllers
    CalendarCtrl,
    // models
    MConversation,
    CConversations
) {

    var ConversationCtrl = Controller.extend({
        routes: {
            '*conversation': 'index',
            ':conversationId(/)': 'viewRoute',
        },

        subRoutes: {
            conversation: '{{{conversationId}}}',
            calendar: '{{conversationId}}/calendar/'
        },

        initialize: function(prefix, opt) {
            _.extend(this, {
                view: {},
                role: opt.role
            });

            var model = this.model || (this.model = new MConversation());

            this.ctrl = {
                calendar: new CalendarCtrl(
                    this.getPrefix('calendar', { userId: ':userId', groupId: ':groupId', conversationId: ':conversationId' }), {
                        layout: this.layoutCtrl,
                        url: this.url.calendar,
                        role: this.role,
                        conversation: model
                    }),
            };

            this.listenTo(this.ctrl.calendar, 'before:route', this.onCalendarRoute);
        },

        showConversation: function(groupId, userId, conversationId) {
            var model = this.model,
                layout = this.getLayout(),
                view = layout.getMemberView().getView('message', {
                    model: model,
                    profile: layout.getMember(),
                    group: layout.getGroup(),
                    role: this.role,
                    url: this.url
                });

            this.when(
                model.setId(conversationId),
                layout.setGroupId(groupId),
                layout.setMemberId(userId, { group: groupId }),
                User.fetch(),
                model.firstFetch()
            ).then(function() {
                layout.showMemberPage(groupId, userId, 'message');
                this.setHeaderTitle(view);
            });

            return this;
        },

        setHeaderTitle: function(view) {
            if (this.role === 'client') {
                this.getLayout().getMemberView().setHeader(view);
            }
        },

        isCalendarUrl: function() {
            return Backbone.history.getFragment().indexOf('calendar') > -1;
        },
        ////////////
        // routes //
        ////////////

        index: function(groupId, userId) {
            this.when(
                User.fetch()
            ).then(function() {
                this.model.setDistantMember(userId);
                this.showConversation(groupId, userId);
            });
        },

        viewRoute: function(groupId, userId, conversationId) {
            if (!(this.isCalendarUrl() && this.model.id === conversationId)) {
                this.showConversation(groupId, userId, conversationId);
            }
        },

        ////////////
        // events //
        ////////////

        onCalendarRoute: function(route, params) {
            this.viewRoute.apply(this, params);
        },

        onLayoutCreation: function(layout) {
            this.profile = layout.getMember();
            this.group = layout.getGroup();
        },

        onBack: function() {
            this.trigger('back');
        },

    });

    return ConversationCtrl;
});

